import { ModelBase } from "@shoothill/core";
import { observable, action } from "mobx";

export class SupplierDocumentModel extends ModelBase<SupplierDocumentModel> {
    @observable
    public id: string | null = null;
    @observable
    public fileName: string = "";
    @observable
    public url: string = "";
    @observable
    public isDeleted: boolean = false;
    @observable
    public createdByUserId: string | null = "";
    @observable
    public createdDate: string | null = "";
    constructor() {
        super();
    }

    @action
    public handleDelete = (val: boolean) => {
        this.isDeleted = val;
    };

    fromDto(model: SupplierDocumentDTO): void {
        this.id = model.id;
        this.fileName = model.fileName;
        this.url = model.url;
        this.isDeleted = model.isDeleted;
        this.createdByUserId = model.createdByUserId;
        this.createdDate = model.createdDate;
    }

    public static fromDtos(dtos: SupplierDocumentDTO[]): SupplierDocumentModel[] {
        const types: SupplierDocumentModel[] = [];

        for (const dto of dtos) {
            const model = new SupplierDocumentModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    toDto(): SupplierDocumentDTO {
        return {
            id: this.id,
            fileName: this.fileName,
            url: this.url,
            isDeleted: this.isDeleted,
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate,
        };
    }
}

export interface SupplierDocumentDTO {
    id: string | null;
    fileName: string;
    url: string;
    isDeleted: boolean;
    createdByUserId: string | null;
    createdDate: string | null;
}
